/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

import { Link } from "react-router-dom";
import { useBilling } from "../hooks/useBilling.js";
import { TRIAL_WARNING_DAYS } from "../billingConfig.js";

export default function TrialBanner() {
  const { subscription, trialDaysLeft, inGrace } = useBilling();
  if (!subscription) return null;

  // Warn only in the final stretch. With the old 7-day trial this threshold
  // meant "always"; with a 14-day trial it means the last week.
  if (subscription.status === "trialing" && trialDaysLeft !== null && trialDaysLeft <= TRIAL_WARNING_DAYS) {
    return (
      <div className="banner banner-info">
        Trial ends in {trialDaysLeft} day{trialDaysLeft === 1 ? "" : "s"}.{" "}
        <Link to="/subscribe">Manage billing</Link>
      </div>
    );
  }
  if (inGrace) {
    return (
      <div className="banner banner-warn">
        Payment failed. Embeds keep serving until{" "}
        {new Date(subscription.grace_until).toLocaleDateString()}.{" "}
        <Link to="/subscribe">Update payment method</Link>
      </div>
    );
  }
  return null;
}
